<template>
  <v-container>
    <v-card
      :loading="false"
      class="elevation-3"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="4">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_from')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.from" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLocale()"
                           @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="toDateFormatted"
                @input="changeDate('to', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_to')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.to" no-title
                           :first-day-of-week="1"
                           :locale="getCurrentLocale()"
                           @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="searchTextRecipient"
            :hint="lang($store, 'sap/listings.global.filter.hints.recipient')"
            persistent-hint
            single-line
            :loading="false"
          />

        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="searchParams.search_manager"
            hint="Менеджер"
            :items="managersItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="searchParams.search_expense_category"
            hint="Категория"
            :items="expenseCategoryItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
      </v-row>
      <download-file-button
        v-if="account.role === MANAGER_TOP"
        :use-download-report-users="true"
        style="position: absolute; top: 5px; right: 5px"
        @click="$emit('download-excel')"
      />

    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment';
/* constants */
import { DATE_ISO } from '@/constants/dates';
import { MANAGER_TOP } from '@/constants/roles';
/* mixins */
import isComponentLoading from '@/mixins/isComponentLoading';
import managersItems from '@/mixins/filters/managersFilter';
import expenseCategoryItems from '@/mixins/filters/expensesCategoryFilter';
import searchRecipientFilter from '@/mixins/filters/searchRecipientFilter';
/* components */
import DownloadFileButton from '@/components/minialerts/DownloadFileButton.vue';
import i18n from '@/i18n';

export default {
  name: 'FilterExpenses',
  mixins: [
    isComponentLoading,
    managersItems,
    expenseCategoryItems,
    searchRecipientFilter,
  ],
  components: {
    DownloadFileButton,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search_recipient: '',
        search_manager: null,
        search_expense_category: null,
      }),
    },
  },
  data() {
    return {
      MANAGER_TOP,
      useNullableManagers: true,
      useNullableExpenseCategory: true,
      searchParams: {},
      menuFrom: false,
      menuTo: false,
    };
  },
  mounted() {
    this.searchParams = {
      order_by: this.defaultSearchParams.order_by || 'datetime',
      order_to: this.defaultSearchParams.order_to || 'asc',
      search_recipient: this.defaultSearchParams.search_recipient,
      search_manager: this.defaultSearchParams.search_manager,
      search_expense_category: this.defaultSearchParams.search_expense_category,
      from: moment()
        .startOf('day')
        .format(DATE_ISO),
      to: null,

    };
  },
  computed: {
    orderByItems() {
      return [
        {
          text: i18n.t('hints.sortByDate'),
          value: 'datetime',
        },
      ];
    },
    account() {
      return this.$store.getters['account/account'];
    },
    fromDateFormatted() {
      // console.log(this.formatDate(this.searchParams.from));
      return this.formatDate(this.searchParams.from);
    },
    toDateFormatted() {
      // console.log(this.formatDate(this.searchParams.to));

      return this.formatDate(this.searchParams.to);
    },
  },
  watch: {
    searchParams: {
      handler(newVal) {
        // console.log(newVal);
        this.$emit('filtering', newVal);
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    changeDate(type, date) {
      if (date === null) {
        this.searchParams[type] = null;
      }
    },
    getCurrentLocale() {
      return window.localStorage.language;
    },
  },
};
</script>

<style scoped>

</style>
